import React from "react"
import styled from "@emotion/styled"
import theme from "../styles/theme"

import Layout from "../components/layout"
import SEO from "../components/seo"

const Container = styled.div`
  max-width: ${theme.maxwidth.default};
  margin-left: auto;
  margin-right: auto;
`

const IndexPage = () => (
  <Layout>
    <SEO title="Privacy policy" />
    <Container>
      <h1>STACK WEBSITE PRIVACY POLICY</h1>

      <h2>1. Introduction</h2>
      <p>
        Stack International Operations Limited, and Stack International US, Inc.
        (“Stack”, “we”, “us” or “our”) are committed to the protection and
        security of your personal data. This Privacy Policy explains how we will
        collect, process, use or share any personal data we collect from you, or
        that you provide to us when you use this website (the “Website”).
      </p>
      <p>
        If you are located in the EEA, Stack is the controller of your personal
        data provided via our Website pursuant to the EU General Data Protection
        Regulation 2016/679.
      </p>
      <p>
        Please read this Privacy Policy to understand how we may process your
        personal data provided via our Website.
      </p>
      <p>
        By visiting our Website, you are acknowledging the terms of this Privacy
        Policy. Any external links to other websites are clearly identifiable as
        such, and we are not responsible for the content or the privacy policies
        of these other websites.
      </p>
      <h2>2. How do we collect information from you?</h2>
      <p>
        Communications via our Website: We collect personal data when you
        provide it to us through communications via our Website. This includes
        where you have contacted us through the channels listed on the Website
        and situations in which you have chosen to provide the information to
        us, including, for example, for recruitment purposes. The type of
        personal data we may collect includes identity data (including name),
        contact data (including email address and telephone number), country,
        location, and any other personal data you provide to us via the
        ‘Contact’ or ‘Let’s talk’ pages on our Website.
      </p>
      <p>
        When you purchase our services: We collect personal data when you
        provide it to us in order for us to provide you with services. The type
        of personal data we may collect includes identity data (including name),
        contact data (including email address and telephone number), country,
        location, and any other personal data you provide to us.
      </p>
      <p>
        Cookies: We may collect information using cookies when you use our
        Website. Cookies are small data files stored on the hard drive of your
        computer or mobile device by a website. We may use both session cookies
        (which expire once you close your web browser) and persistent cookies
        (which stay on your computer or mobile device until they expire or you
        delete them) to provide you with a more personal and interactive
        experience on our Website. Our Website uses the following types of
        cookies for the purposes:
      </p>
      <div align="left">
        <table>
          <colgroup>
            <col width="106" />
            <col width="510" />
          </colgroup>
          <tbody>
            <tr>
              <td>
                <p>Type of cookie</p>
              </td>
              <td>
                <p>Purpose</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Essential Cookies</p>
              </td>
              <td>
                <p>
                  These cookies are essential to provide you with services
                  available through our Website and to enable you to use some of
                  its features. Without these cookies, the services that you
                  have asked for cannot be provided, and we only use these
                  cookies to provide you with those services.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Analytics and Performance Cookies</p>
              </td>
              <td>
                <p>
                  These cookies are used to collect information about traffic to
                  our Website and how users use our Website. The information
                  gathered via these cookies does not “directly” identify any
                  individual visitor. However, it may render such visitors
                  “indirectly identifiable”. This is because the information
                  collected is typically linked to a pseudonymous identifier
                  associated with the device you use to access our Website. The
                  information collected is aggregated and anonymous. We use this
                  information to help operate our Website more efficiently, to
                  gather broad demographic information and to monitor the level
                  of activity on our Website.
                </p>

                <p>
                  We use Google Analytics and Hubspot for this purpose. Google
                  Analytics uses itsThey use their own cookies. It is only used
                  to and we only use them to improve how our Website works. You
                  can find out more information about Google Analytics cookies
                  here:
                </p>

                <p>
                  https://developers.google.com/analytics/resources/concepts/gaConceptsCookies
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p>Social Media Cookies</p>
              </td>
              <td>
                <p>
                  These cookies are used when you share information using a
                  social media sharing button or “like” button on our Website or
                  you link your account or engage with our content on or through
                  a social networking website such as Facebook, Twitter or
                  LinkedIn. The social network will record that you have done
                  this.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h2>3. Purposes for processing your personal data</h2>
      <p>
        We process any personal data you provide to us to ensure compliance with
        local legal and regulatory requirements and for the purposes of our
        legitimate business interests, including:
      </p>
      <ol>
        <li>
          <p>
            to enable us to respond to an enquiry or other request you make when
            you contact us via our Website;
          </p>
        </li>
        <li>
          <p>
            to form a view on what may be of interest to you, and what services
            and offers may be relevant for you;
          </p>
        </li>
        <li>
          <p>
            to comply with our legal obligations, standards, policies and
            procedures; and
          </p>
        </li>
        <li>
          <p>
            to better understand how you interact with our Website, including
            its functionality and features, and ensure that content is presented
            in the most effective way.
          </p>
        </li>
      </ol>
      <h2>4. Sharing your information</h2>
      <p>We may share your personal data with:</p>
      <ol>
        <li>
          <p>our affiliated companies;</p>
        </li>
        <li>
          <p>
            Government bodies and agencies in the UK and overseas to comply with
            our legal and regulatory obligations;
          </p>
        </li>
        <li>
          <p>
            a prospective seller or buyer in the event of a sale or purchase of
            any Stack business or asset so that the buyer can continue to
            provide you with information and services; and
          </p>
        </li>
        <li>
          <p>
            our service providers that we engage to provide services for us.
            Where we provide your personal data to third party services
            providers, they are required to keep your personal data confidential
            and secure, and must only use your personal data as instructed by
            us.
          </p>
        </li>
      </ol>
      <p>
        We may also disclose your personal data where required to respond to
        authorised requests from government authorities or where required by
        law. Where we are required by law, we may also disclose your personal
        data where it is necessary to enforce or apply this Privacy Policy or
        other agreements, to investigate or protect the rights, property or
        safety of Stack and our group companies, our products and services and
        our customers, distributors or business partners or to prevent or take
        action regarding illegal activities or fraud, situations involving
        potential threats to the safety of any person or as evidence in
        litigation.
      </p>
      <h2>5. Storing your personal data</h2>
      <p>
        Your personal data collected via our Website will be stored on servers
        located in the USA.
      </p>
      <p>
        We have implemented appropriate safeguards, to protect your personal
        data when it is transferred outside the European Economic Area (“EEA”),
        including the execution of data transfer agreements with recipients of
        the information.
      </p>
      <h2>6. Marketing communications preferences</h2>
      <p>
        You can ask us to stop sending you marketing messages at any time by
        following the opt-out links on any marketing message sent to you, or by
        contacting us at any time using the contact details in this Privacy
        Policy.
      </p>
      <h2>7. Data retention</h2>
      <p>
        We will only retain your personal information for as long as necessary
        to fulfil the purposes we collected it for, including for the purposes
        of satisfying any legal, accounting, or reporting requirements. To
        determine the appropriate retention period for personal information, we
        consider the amount, nature, and sensitivity of the personal data, the
        potential risk of harm from unauthorised use or disclosure of your
        personal data, the purposes for which we process your personal
        information and whether we can achieve those purposes through other
        means, and the applicable legal requirements.
      </p>
      <h2>8. Your rights</h2>
      <p>
        You may inform us of any changes in your personal data, and in
        accordance with our obligations under applicable data protection laws,
        we will update or delete your personal data accordingly.
      </p>
      <p>
        If you are located in the EEA, you may have the right to: (a) request
        access to personal data we hold about you; (b) request we correct any
        inaccurate personal data we hold about you; (c) request we delete any
        personal data we hold about you; (d) restrict the processing of personal
        data we hold about you; (e) object to the processing of personal data we
        hold about you; and/or (f) where we process your personal data to fulfil
        a contract between us, receive any personal data we hold about you in a
        structured and commonly used machine-readable format or have such
        personal information transmitted to another company.
      </p>
      <p>
        We may ask you for additional information to confirm your identity and
        for security purposes, before disclosing information requested to you.
      </p>
      <p>
        To exercise any of your rights in connection with your personal data,
        please contact us by email at hello@stackglobal.io or by mail to 8th
        Floor, 11 Newhall Street, Birmingham, United Kingodm, B3 3NY. We will
        process any request in line with any local laws and our policies and
        procedures. If you are located in the EEA, you have the right to lodge a
        complaint about how we process your personal data with the supervisory
        authority in your country.
      </p>
      <h2>9. Changes to this Privacy Policy</h2>
      <p>
        Any changes to this Privacy Policy in the future will be posted on this
        page and, where appropriate, notified to you by e-mail. Please check
        back frequently to see any updates or changes to this Privacy Policy.
      </p>
      <h2>10. How you can contact us</h2>
      <p>
        If you have any questions about the processing of personal data via this
        Website, please contact us by email at: hello@stackglobal.io. If you
        contact us, we will do our utmost best to address any concerns you may
        have about our processing of your personal data.
      </p>
      <div></div>
    </Container>
  </Layout>
)

export default IndexPage
